import { GuaranteeCreatorType, PrescriptionStatus } from '@lib/prescriptions/data-access';

import { AppointmentTypes, VisitStatusTypes } from '@lib/core/models/visit.interface';

export interface PrescriptionDialog {
  creatorType: GuaranteeCreatorType;
  creatorName: string;
  isLiloStaff: boolean;
  creationDate: string;
  prescriptionType: string;
  prescriptionName: string;
  duration?: string;
  dailyDosage?: string;
  treatmentDosage?: string;
  status: PrescriptionStatus;
  rejectionReason?: string;
}

export const PrescriptionDialogLabels = {
  creatorTypeLabel: 'Спеціаліст, який створив',
  creatorNameLabel: 'ПІБ спеціаліста',
  creationDateLabel: 'Дата та час створення',
  prescriptionTypeLabel: 'Тип медичної послуги',
  prescriptionNameLabel: 'Назва',
  durationLabel: 'Тривалість лікування (днів)',
  dailyDosageLabel: 'Добова кількість',
  treatmentDosageLabel: 'Курсова кількість',
  statusLabel: 'Статус',
};

export interface VisitDialog {
  userId: string;
  guaranteeId: string;
  serviceType: AppointmentTypes;
  serviceName: string;
  status: VisitStatusTypes;
  doctorSpecialty: string;
  doctorName: string;
  visitDate: string;
  clinicName?: string;
  location: string;
  orderNumber?: string;
  expirationDate?: string;
  prescriptions?: string[];
}

export const VisitDialogLabels = {
  serviceNameLabel: 'Назва послуги',
  drugsServiceDefaultName: 'Замовлення в аптеці',
  doctorSpecialtyLabel: 'Спеціалізація лікаря',
  doctorNameLabel: 'ПІБ лікаря',
  visitDateLabel: 'Дата та час',
  clinicNameLabel: 'Назва клініки',
  locationLabel: 'Адреса',
  orderNumberLabel: 'Номер замовлення',
  prescriptionsLabel: 'Список замовлених ліків',
  expirationDateLabel: 'Забрати до',
  statusLabel: 'Статус',
};
